export const APP_URLS = {
    DASHBOARD: '/',
    RESET_PASSWORD: '/reset-password',
    PROFILE: '/profile',
    LOGIN: '/login',
    REPORT: '/report',
    PROSPECTS: {
        ROUTES: "/prospects",
        ALL: "/prospects/all",
        OPEN: "/prospects/:id",
        VIEW: "/prospects/view/:id",

    },
    PAYSLIP: {
        ROUTE: '/payslip',
        SPECIFIC: '/payslip/:id'
    },
    EMPLOYEES: {
        ROUTE: '/employees',
        DETAILS: '/employees/:id'
    },
    USERS: {
        ROUTE: '/users',
        DETAILS: '/users/:id'
    },
    ATTENDANCE: {
        ROUTE: '/attendance',
        LIST: '/attendance/list',
    },
    CALENDAR: {
        ROUTE: '/calendar',

    },
    CONVERSATION: {
        ALL: '/conversation/all',
        ROUTE: '/conversation',
    },
    LEAVES: {
        ROUTE: '/leaves',
        ALL: '/leaves/all'

    },
    ORGANIZATION: {
        ROUTE: '/organization',
        SECURITY: '/organization/security',
        SETTINGS: '/organization/settings'
    },
    LEADS: {
        ROUTE: '/leads',
        REPORTS: '/leads/reports'
    },
    APPLICATION: {
        ROUTE: '/application',
        CREATE: '/application/create',
        VIEW: '/application/:id',
        EDIT: '/application/edit/:id',
    }
}


// development
// export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://127.0.0.1:3300/'
export const BASE_URL = process.env.REACT_APP_BASE_URL;
// export const IMAGE_URL = process.env.REACT_APP_BASE_URL || 'https://dy4re6kq2a7jv.cloudfront.net/'
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
// export const IMAGE_URL = 'https://bccrmimage.s3.ap-south-1.amazonaws.com/'


// production
// export const BASE_URL = "https://api.be-connect.co.uk/"
// export const IMAGE_URL = 'https://d17g29gcr7s2yh.cloudfront.net/'
// export const IMAGE_URL = 'https://beconnectcrm.s3.eu-west-2.amazonaws.com/'


export const CHAT_SOCKET_URL = `${BASE_URL}chat`
export const NOTIFICATION_SOCKET_URL = `${BASE_URL}notification`



export const API_URLS = {
    EXTERNAL: {
        COUNTRY: 'https://restcountries.com/v2/all',
        // ADDRESS_LOOKUP: `https://ws.postcoder.com/pcw/${ADDRESS_API_KEY}/address/${ADDRESS_COUNTRY}/:postcode`
        // loquate api
        // ADDRESS_LOOKUP: `https://api-us.platform.loqate.com/address-capture/find`,
        // GET_ADDRESS_DATA: `https://api-us.platform.loqate.com/address-capture/retrieve`


        ADDRESS_LOOKUP: `https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws`,
        GET_ADDRESS_DATA: `https://api.addressy.com/Capture/Interactive/Retrieve/v1.2/json3.ws`
    },
    USERS: {
        LOGIN: `${BASE_URL}users/login`,
        RESET_PASSWORD: `${BASE_URL}users/reset-password`,
        CHANGE_PASSWORD: `${BASE_URL}users/change-password`,
        ROUTE: `${BASE_URL}users`,
        PROFILE: `${BASE_URL}users/profile`,
        ASSIGN_TO_TL: `${BASE_URL}users/assign-employee`,
        EMPLOYEE: {
            ROUTE: `${BASE_URL}users/employee`,
            CREATE_EMERGENCY_CONTACT: `${BASE_URL}users/employee/emergency-contact`,
            UPDATE_EMERGENCY_CONTACT: `${BASE_URL}users/employee/emergency-contact`
        },
        CONVERSATION: {
            ALL_ROOMS: `${BASE_URL}chat/all-conversations`,
            MESSAGE: `${BASE_URL}chat/all-messages`,
            USER_LIST: `${BASE_URL}chat/users-list`
        },
        DASHBOARD: `${BASE_URL}users/dashboard`,
        ATTENDANCE: {
            ROUTE: `${BASE_URL}attendance`,
            GET_TODAY_ATTENDANCE: `${BASE_URL}attendance/today`,
            CLOSE_ATTENDANCE: `${BASE_URL}attendance/close`,
            MONTHLY_ATTENDANCE_REPORT: `${BASE_URL}attendance/monthly-report`,
            REOPEN_ATTENDANCE: `${BASE_URL}attendance/open/:id`,
            BREAK: {
                ROUTE: `${BASE_URL}attendance/break`,
                CLOSE_BREAK: `${BASE_URL}attendance/break/close`,
                CREATE_BREAK: `${BASE_URL}attendance/break/create`
            }
        },
        LEAVES: {
            ASSIGN_LEAVE: `${BASE_URL}leave/employee/assign-leaves`,
            ROUTE: `${BASE_URL}leave`,
            ALL: `${BASE_URL}leave/all`,
            LEAVES_BALANCE:`${BASE_URL}leave/employee/leave-balance`
        }
    },
    LOGS: {
        USER_DISABLED_LOGS: `${BASE_URL}logs/users`
    },
    PROSPECTS: {
        ROUTE: `${BASE_URL}prospects`,
        ALL_LIST: `${BASE_URL}prospects/all`,
        USERS_LIST: `${BASE_URL}users/prospect-users`,
        MONTLY_PROSPECT_REPORT: `${BASE_URL}prospects/reports`,
        TRASH: `${BASE_URL}prospects/trash`,
        FORCED_DELETE: `${BASE_URL}prospects/force`,
        RESTORE: `${BASE_URL}prospects/restore`
    },
    APPLICATIONS: {
        ROUTE: `${BASE_URL}application`,
        COUNT: `${BASE_URL}application/count`,
        SAVE: `${BASE_URL}application/save-application`,
        PERSON: {
            ROUTE: `${BASE_URL}person`,
            REMOVE_PERSON: `${BASE_URL}application/person/:appId`
        },
        NOTES: `${BASE_URL}application-history/notes`,
        ACTIVITY_LOGS: `${BASE_URL}application-history/logs`,
        CHANGE_STATUS: `${BASE_URL}application/status/:id`,
        ASSIGN_USER: `${BASE_URL}application/assign/:id`
    },
    ORGANIZATION: {
        ROUTE: `${BASE_URL}org`,
        IP: {
            ROUTE: `${BASE_URL}org/ip`,
            CURRENT_IP: `${BASE_URL}org/ip/getcurrent`,
        },
        CALENDAR: {
            ROUTE: `${BASE_URL}calendar`,
            RANGE: `${BASE_URL}calendar/range-events`
        },
        DROPDOWN: {
            BUSINESS_DESCRIPTION: `${BASE_URL}org/dropdown/description`,
            BUSINESS_TYPE: `${BASE_URL}org/dropdown/type`,
            AQUIRER: `${BASE_URL}org/device/aquirer`,
            TERMINAL_TYPE: `${BASE_URL}org/device/terminal-type`,
            TERMINAL_MODEL: `${BASE_URL}org/device/terminal-model`
        },
        SHIFT: {
            ADD_SHIFT: `${BASE_URL}users/shift`,
            VIEW_SHIFT: `${BASE_URL}users/shift`,
            UPDATE_SHIFT: `${BASE_URL}users/shift/:id`
        }
    },
    FILES: {
        UPLOAD_FILES: `${BASE_URL}files/upload`,
        DELETE_FILE: `${BASE_URL}files/:id`,
        PROFILE: `${BASE_URL}files/profile`,
        REPLACE_FILE: `${BASE_URL}files/:id`
    },
    PAYSLIP: {
        ROUTE: `${BASE_URL}payslip`,
        NEW_PAYSLIP_ROUTE: `${BASE_URL}payslip/new-payslip`,
        SPECIFIC: `${BASE_URL}payslip/:id`,
        ME: `${BASE_URL}payslip/me`,
        DOWNLOAD: `${BASE_URL}payslip/download`,
    },
    REMAINDER: {
        CREATE: `${BASE_URL}remainders/create`,
        UPDATE: `${BASE_URL}remainders/update`,
        DELETE: `${BASE_URL}remainders/delete`,
        REPORT: `${BASE_URL}remainders/report`,
    }
}
